import gql from 'graphql-tag';
import RecipeTagFragment from './fragments/RecipeTag.gql';

export default gql`
  mutation createRecipeTags($input: CreateRecipeTagsInput!) {
    createRecipeTags(input: $input) {
      recipeTags {
        ...RecipeTagFragment
      }
    }
  }
  ${RecipeTagFragment}
`;
